import React from "react";
import { useNavigate } from "react-router-dom";

export default function Section9() {
  const navigate = useNavigate();

  return (
    <div className="w-full Section9 py-[45px] bg-[#cd2122]">
      <div className="container-1280 section9-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%] text-center">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] my-[0.67em] text-white">
          Build Your Mobile App With Mean3
        </h2>

        <p className="w-full md:w-[70%] mx-auto leading-[22px] text-white/90 text-sm md:text-base font-open mb-3">
          Have an app idea? Let our team help you understand the right
          approach, technology, timeline, and budget for your project.
        </p>
        <p className="w-full md:w-[70%] mx-auto leading-[22px] text-white/90 text-sm md:text-base font-open mb-8">
          We provide honest guidance without unnecessary complexity.
        </p>

        <button
          onClick={() => navigate("/contact-mean3")}
          className="inline-block py-[12px] px-[30px] bg-white rounded-[3px] font-bold text-[#cd2122] border-none leading-[1.15] hover:bg-[#f2f2f2] transition-colors"
        >
          Book a Free Consultation
        </button>
      </div>
    </div>
  );
}
